<template>
    <div class="discuss-page">
        <div class="container-fluid mt-1">
            <div class="row">
                <div class="col-xl-8 mb-5 mb-xl-0">
                    <div class="topik-form">
                        <b-form class="topik-diskusi-form">
                            <b-form-textarea
                                id="title-topik-input"
                                class="title-topik-input"
                                name="title-topik-input"
                                placeholder="Topik Diskusi"
                                v-model="discuss_form.name"
                                rows="2"
                                no-resize
                            ></b-form-textarea>
                            <hr class="m-0">
                            <b-form-textarea
                                id="desc-topik-input"
                                class="desc-topik-input"
                                name="desc-topik-input"
                                placeholder="Apa yang ingin anda diskusikan?"
                                v-model="discuss_form.description"
                                rows="4"
                                no-resize
                            ></b-form-textarea>
                            <div class="topik-diskusi-form-footer d-flex justify-content-end">
                                <square-loader :loading="showLoader" :color="'#ca062a'" :size="'25px'"></square-loader>
                                <b-button v-if="!showLoader" variant="primary" size="sm" style="width: 25%;" @click="addDiscussion">KIRIM</b-button>
                            </div>
                        </b-form>
                    </div>
                    <div v-if="discuss.discussion_list && discuss.discussion_list.length > 0">
                        <div v-for="(item, index) in discuss.discussion_list" :key="index" class="card my-4">
                            <div class="card-header d-flex justify-content-between align-items-center">
                                <div class="left-content d-flex">
                                    <div class="mx-1">
                                        <img :src="item.image_path" alt="" style="max-width: 50px; max-height: 50px;">
                                    </div>
                                    <div class="mx-1">
                                        <div class="user-discuss">
                                            <a href="javascript:void(0);" class="text-uppercase" style="font-weight: 500;">{{ item.full_name }}</a>&nbsp;
                                            <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>&nbsp;
                                            <a href="javascript:void(0);" class="">{{ item.name }}</a>
                                        </div>
                                        <div class="role-article">
                                            <small class="text-muted">{{ item.created }}</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="right-content" v-if="item.is_me">
                                    <a href="javascript:void(0)" class="icon-clicked" @click="confirmDeleteDiscussion(item.id)"><i class="fa fa-trash" aria-hidden="true"></i></a>
                                </div>
                            </div>
                            <div class="card-body">
                                <p class="">{{ item.description }}</p>
                            </div>
                            <div class="card-footer" style="font-size: 14px;">
                                <div class="materi-comment d-flex text-muted">
                                    <div class="mx-1" style="cursor: pointer;" v-b-toggle="'collapse-comment-'+item.id">
                                        {{ item.comments.length }} Komentar
                                    </div>
                                    <div class="line-with-icon mx-1 mb-0" style="cursor: pointer;" @click="focusInput('input-comment-'+item.id, 0)">
                                        <i class="fa fa-comment" aria-hidden="true"></i>
                                        <div>
                                            Komentari
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <b-collapse v-if="item.comments && item.comments.length > 0" :id="'collapse-comment-'+item.id">
                                    <b-card style="border-bottom-right-radius: unset; border-bottom-left-radius: unset;">
                                        <div :class="'item-comment-'+index" v-for="(comment, index) in item.comments" :key="'comment-row-' + index">
                                            <div class="d-flex my-3" style="border-bottom: 1px black" :class="(index+1) == item.comments.length ? 'mb-0' : ''">
                                                <div class="mx-1">
                                                    <img :src="comment.image_path" alt="" style="max-width: 50px; max-height: 50px;">
                                                </div>
                                                <div class="mx-1" style="width: 100%">
                                                    <div class="comment-user">
                                                        <div class="name">
                                                            {{comment.full_name}}
                                                        </div>
                                                        <div class="created-time">
                                                            <sup>{{comment.created}}</sup>
                                                        </div>
                                                        <div class="desc">
                                                            {{comment.comment}}
                                                        </div>
                                                    </div>
                                                    <hr class="my-1">
                                                    <div class="comment-comment-button d-flex text-muted" style="font-size: 13px;">
                                                        <div class="mx-1" style="cursor: pointer;" v-b-toggle="'collapse-balasan-'+comment.id">
                                                            {{ comment.reply.length }} Balasan
                                                        </div>
                                                        <div class="line-with-icon mx-1 mb-0" style="cursor: pointer;" @click="focusInput('input-balasan-'+comment.id, 0)">
                                                            <i class="fa fa-comment" aria-hidden="true"></i>
                                                            <div>
                                                                Balas
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <br>
                                                    <b-collapse v-if="comment.reply && comment.reply.length > 0" :id="'collapse-balasan-'+comment.id">
                                                        <b-card style="border-bottom-right-radius: unset; border-bottom-left-radius: unset;">
                                                            <div :class="'item-balasan-'+index2" v-for="(balas, index2) in comment.reply" :key="'comment-balasan-row-' + index2">
                                                                <div class="d-flex my-3" style="border-bottom: 1px black" :class="(index2+1) ==  comment.reply.length ? 'mb-0' : ''">
                                                                    <div class="mx-1">
                                                                        <img :src="balas.image_path" alt="" style="max-width: 50px; max-height: 50px;">
                                                                    </div>
                                                                    <div class="mx-1" style="width: 100%">
                                                                        <div class="balas-user">
                                                                            <div class="name">
                                                                                {{balas.full_name}}
                                                                            </div>
                                                                            <div class="created-time">
                                                                                <sup>{{balas.created}}</sup>
                                                                            </div>
                                                                            <div class="desc">
                                                                                {{balas.comment}}
                                                                            </div>
                                                                        </div>
                                                                        <hr class="my-1">
                                                                    </div>
                                                                </div>
                                                                <hr class="m-0" v-show="(index2+1) != comment.reply.length">
                                                            </div>
                                                        </b-card>
                                                    </b-collapse>
                                                    <b-form @submit="onSubmitReply(item,comment)">
                                                    <b-form-input
                                                        :id="'input-balasan-'+comment.id"
                                                        :ref="'input-balasan-'+comment.id"
                                                        placeholder="Tuliskan balasan disini"
                                                        v-model="comment.comment_reply"
                                                        style="background: transparent; border-radius: unset; font-size: 13px; height: 45px;"
                                                        autocomplete="off"
                                                    ></b-form-input>
                                                    </b-form>
                                                </div>
                                            </div>
                                            <hr class="m-0" v-show="(index+1) != item.comments.length">
                                        </div>
                                    </b-card>
                                </b-collapse>
                                <b-form @submit="onSubmitComment(item)">
                                    <b-form-input
                                        :id="'input-comment-'+item.id"
                                        :ref="'input-comment-'+item.id"
                                        placeholder="Tuliskan komentar disini"
                                        v-model="item.comment"
                                        style="background: transparent; border-radius: unset; font-size: 13px; height: 45px;"
                                        autocomplete="off"
                                    ></b-form-input>
                                </b-form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4">
                    <div class="card" >
                        <div class="card-header row align-items-center bg-transparent">
                            <div class="d-flex justify-content-between" style="align-items: center;">
                                <div class="col">
                                    <h6 class="text-uppercase ls-1 mb-1">Info</h6>
                                </div>
                                <div >
                                    <b-dropdown id="dropdown-1" right text="Kembali" size="sm" class="m-md-2">
                                        <b-dropdown-item ><router-link :to="{ name: 'subject-detail', params:{ subjectId: discuss.subjects_id} }" class="icon-clicked p-1"><i class="clr-red fa fa-arrow-left" aria-hidden="true"></i> Halaman Modul</router-link></b-dropdown-item>
                                    </b-dropdown>   
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="identity px-2">
                                <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{discuss.user_name}}</p>
                                <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{discuss.user_status}}</p>
                                <p class="line-with-icon"><i class="clr-red fa fa-book" aria-hidden="true"></i>{{discuss.subject_name}}</p>
                                <p class="line-with-icon"><i class="clr-red fa fa-folder-open" aria-hidden="true"></i>{{discuss.name}}</p>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="card">
                                <div class="card-body text-center">
                                    <h6>{{discuss.total_discussion}}</h6>
                                    <h6>Topik Diskusi</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { EventBus } from '@/eventBus.js'
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    export default {
        components: {
            SquareLoader,
        },
        data() {
            return {
                showLoader: false,
                discuss_form: {
                    learning_activity_id: this.$route.params.modulId,
                    name: null,
                    description: null
                },
                form_comment: {
                    discussion_id: null,
                    parent_id: 'X0w1O1km97SKnZxxqBZwfR',
                    comment: null
                }
            };
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                discuss: 'getDiscussOverview'
            })
        },
        methods: {
            focusInput(val, index = null) {
                if (index == 0) {
                    this.$refs[val][0].focus();
                } else {
                    this.$refs[val].focus()
                }
            },
            resetDiscussionForm() {
                this.discuss_form.name = null
                this.discuss_form.description = null
            },
            resetComment() {
                this.form_comment.discussion_id = null
                this.form_comment.parent_id = 'X0w1O1km97SKnZxxqBZwfR'
                this.form_comment.comment = null
            },
            async getDiscussOverview() {
                let modulId = this.$route.params.modulId
				await this.$store.dispatch('getDiscussOverview', { modulId })
					.then(() => {
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
            },
            async onSubmitComment(param) {
                if (param.comment) {
                    EventBus.$emit('showLoaderOverlay', true)
                    this.form_comment.discussion_id = param.id
                    this.form_comment.comment = param.comment
                    let form = this.form_comment
                    await this.$store.dispatch('addDiscussComment', form )
                        .then(() => {
                            this.getDiscussOverview()
                            param.comment = null
                            this.resetComment()
                        })
                        .catch((err)=> {
                            this.$swal.fire('Failed', err.response.data.message, 'error')
                        })
                    await EventBus.$emit('hideLoaderOverlay', true)
                }
            },
            async onSubmitReply(diskusi, param) {
                if (param.comment_reply) {
                    EventBus.$emit('showLoaderOverlay', true)
                    this.form_comment.discussion_id = diskusi.id
                    this.form_comment.parent_id = param.id
                    this.form_comment.comment = param.comment_reply
                    let form = this.form_comment
                    await this.$store.dispatch('addDiscussReply', form )
                        .then(() => {
                            this.getDiscussOverview()
                            param.comment_reply = null
                            this.resetComment()
                        })
                        .catch((err)=> {
                            this.$swal.fire('Failed', err.response.data.message, 'error')
                        })
                    await EventBus.$emit('hideLoaderOverlay', true)
                }
            },
            async addDiscussion() {
                let form = this.discuss_form
                if (form.name && form.description) {
                    this.showLoader = true
                    await this.$store.dispatch('addDiscussion', form )
                        .then((res) => {
                            this.getDiscussOverview()
                            this.resetDiscussionForm()
                            this.$swal.fire('Success', res.message, 'success')
                            this.showLoader = false
                        })
                        .catch((err)=> {
                            this.showLoader = false
                            this.$swal.fire('Failed', err.response.data.message, 'error')
                        })
                }
            },
            async confirmDeleteDiscussion(discussId) {
                this.$swal.fire({
                    title: 'Apakah anda yakin?',
                    text: '',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, saya yakin',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.value) {
                        this.deleteDiscuss(discussId)
                    }
                })
            },
            async deleteDiscuss(id) {
				await this.$store.dispatch('deleteDiscuss', { id })
					.then((res) => {
                        this.getDiscussOverview()
                        this.$swal.fire('Success', res.message, 'success')
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
            }
        },
        created() {
            this.setCurrentModulId(this.$route.params.modulId)
            this.getDiscussOverview()
        }
    }
</script>

<style lang="css" scoped>
.topik-diskusi-form {
    -webkit-border-radius: 4px;
    border-radius: 4px;
    background: #fff;
    border: 1px solid #d8e2e7;
    margin: 0 0 20px;
}
.title-topik-input:focus, .desc-topik-input:focus {
    border-color: transparent !important;
    -webkit-box-shadow: unset;
    box-shadow: unset;
}
.title-topik-input {
    height: 50px;
}
.desc-topik-input {
    height: 100px;
}
.title-topik-input, .desc-topik-input {
    background: 0 0;
    border: none;
    -webkit-border-radius: 0;
    border-radius: 0;
    padding: 15px;
    color: #343434!important;
    width: 100%;
    border-top: solid 1px #d8e2e7;
    min-height: 55px;
    overflow: hidden;
    resize: none;
}
.topik-diskusi-form-footer {
    background: #fbfcfd;
    padding: 12px 15px;
    border-top: solid 1px #d8e2e7;
}
.btn-primary {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
}
.btn-primary:hover, .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:focus {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
    -webkit-box-shadow: unset;
    box-shadow: unset;
}
.user-discuss a {
    color: black;
}
.user-discuss a:hover {
    color: #ca062a;
}
</style>